module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-top": "60px",
      "background": "#f5f5f5"
    }
  }, [_c('Header', {
    staticClass: "black"
  }), _vm._v(" "), _c('div', {
    staticClass: "informateion"
  }, [_c('h2', [_vm._v("消息列表")]), _vm._v(" "), _c('ul', {
    staticClass: "infor-list"
  }, _vm._l((_vm.msgList), function(item, index) {
    return _c('li', {
      staticClass: "infor-list-li"
    }, [_c('ul', {
      staticClass: "infor-list-items"
    }, [_vm._m(0, true), _vm._v(" "), _c('li', [_c('p', [_c('span', [_vm._v(_vm._s(item.msg))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(item.addTime)))])])]), _vm._v(" "), _c('li', {
      staticClass: "del",
      on: {
        "click": function($event) {
          return _vm.deleteMsg(item.id)
        }
      }
    }, [_vm._v("删除")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "page-size": 10,
      "current": _vm.listData.pageNo
    },
    on: {
      "on-change": _vm.queryMsgList
    }
  })], 1)]), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "items-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/va.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b0f2407","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/informatiList/inform.vue
// module id = 1285
// module chunks = 37